import type { RequiredWhenFieldCondition } from '../types/fieldCondition.types';

export const matchesFieldCondition = (
	value: unknown,
	condition: RequiredWhenFieldCondition
) => {
	if (condition.is !== undefined && value !== condition.is) return false;
	if (condition.isNot !== undefined && value === condition.isNot) return false;
	return true;
};
